import type { IconProps } from "./icon-types";

/**
 * 6점 그립 드래그 핸들. 행/아이템 재정렬의 grab 핸들 등 "여기를 잡아 끄세요" 영역에 쓴다.
 * 색은 `currentColor`를 상속하므로 호출부에서 색·크기를 지정한다.
 * 점은 round linecap의 미소 세그먼트로 그린다 — 단일 `<path>`+stroke 구조가 공개 계약이라
 * (소비처가 path·stroke를 스타일링/조회할 수 있음) DOM 형태를 바꾸지 않는다.
 */
export const DragHandleIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true" {...props}>
    <path
      d="M6 4h.01M10 4h.01M6 8h.01M10 8h.01M6 12h.01M10 12h.01"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
  </svg>
);
